<template>
  <div id="app-root">
    <router-view></router-view>
    <AppToast />
  </div>
</template>

<script>
import AppToast from '@/components/AppToast.vue'

export default {
  name: 'App',
  components: { AppToast }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
